import * as React from "react";
import { Dialog } from "components/dialog";
import { format } from "lib/globalize-util";
import Button from "components/form/button";

interface IProps {
    onRequestClose: () => void;
    onSubmit: () => void;
}

export default class BuyerProfileModal extends React.PureComponent<IProps, {}> {
    render() {
        return (
            <Dialog
                open={true}
                title={format("Missing Basic Retailer Info")}
                bodyStyle={{ padding: "16px 32px" }}
                style={{ margin: "auto" }}
                onRequestClose={this.props.onRequestClose}
                actions={[
                    <Button
                        label={format("Return to profile")}
                        style={{ marginRight: "16px" }}
                        onClick={this.props.onRequestClose}
                        key="return"
                    />,
                    <Button
                        primary={true}
                        label={format("Complete details now")}
                        onClick={this.props.onSubmit}
                        key="complete"
                    />,
                ]}
            >
                {
                    // tslint:disable-next-line:max-line-length
                    format(
                        "Thanks for your interest in this brand! To continue this connection request, we need some additional information about your store. Would you like to fill this information out now?",
                    )
                }
            </Dialog>
        );
    }
}
